import { ClipPath, G, Path, Rect, Svg } from 'react-native-svg';
import { IconProps } from './types';
import { StyleProp, ViewStyle } from 'react-native';

export const IconBack = ({
  width = 32,
  height = 32,
  color,
  style,
}: IconProps & { style?: StyleProp<ViewStyle> }) => (
  <Svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
    style={style}
  >
    <G clipPath="url(#clip0_3608_8954)">
      <Path
        fill={color}
        d="M10.4337 17.3337L16.9671 23.8671C17.2337 24.1337 17.3615 24.4448 17.3504 24.8004C17.3393 25.1559 17.2004 25.4671 16.9337 25.7337C16.6671 25.9782 16.3559 26.1059 16.0004 26.1171C15.6448 26.1282 15.3337 26.0004 15.0671 25.7337L6.26706 16.9337C6.13372 16.8004 6.03928 16.6559 5.98372 16.5004C5.92817 16.3448 5.90039 16.1782 5.90039 16.0004C5.90039 15.8226 5.92817 15.6559 5.98372 15.5004C6.03928 15.3448 6.13372 15.2004 6.26706 15.0671L15.0671 6.26706C15.3115 6.02261 15.6171 5.90039 15.9837 5.90039C16.3504 5.90039 16.6671 6.02261 16.9337 6.26706C17.2004 6.53372 17.3337 6.85039 17.3337 7.21706C17.3337 7.58372 17.2004 7.90039 16.9337 8.16706L10.4337 14.6671H25.3337C25.7115 14.6671 26.0282 14.7948 26.2837 15.0504C26.5393 15.3059 26.6671 15.6226 26.6671 16.0004C26.6671 16.3782 26.5393 16.6948 26.2837 16.9504C26.0282 17.2059 25.7115 17.3337 25.3337 17.3337H10.4337Z"
      />
    </G>
    <ClipPath id="clip0_3608_8954">
      <Rect width={32} height={32} fill="white" />
    </ClipPath>
  </Svg>
);
